import classNames from 'classnames'
import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import './index.less'
import Button from '../../baseComponent/button'
import { renderCompat } from '../../utils/renderCompat'
import Icon from '../icon'

let cached

function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0
  }

  if (fresh || cached === undefined) {
    const inner = document.createElement('div')
    inner.style.width = '100%'
    inner.style.height = '200px'
    const outer = document.createElement('div')
    const outerStyle = outer.style
    outerStyle.position = 'absolute'
    outerStyle.top = 0
    outerStyle.left = 0
    outerStyle.pointerEvents = 'none'
    outerStyle.visibility = 'hidden'
    outerStyle.width = '200px'
    outerStyle.height = '150px'
    outerStyle.overflow = 'hidden'
    outer.appendChild(inner)
    document.body.appendChild(outer)
    const widthContained = inner.offsetWidth
    outer.style.overflow = 'scroll'
    let widthScroll = inner.offsetWidth

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth
    }

    document.body.removeChild(outer)
    cached = widthContained - widthScroll
  }

  return cached
}

const Modal = (props) => {
  const {
    className, style, title, onClose, confirm, confirmText, info, onOk, wrapStyle, closeIcon, hiddenCloseIcon, maskClosable = false,
    closeAfterOk = true, okText, onCancel, cancelText, visible, onVisibleChange, size, hiddenFooter, footer, unmount
  } = props
  const $wrap = useRef()
  const bodyWidth = useRef()

  useEffect(() => {
    return () => {
      const bodyClass = document.body.className.split(' ')
      if (document.querySelectorAll('.meinian-modal .mask').length < 2) {
        document.body.className = bodyClass.filter(m => m !== 'meinian-modal-open').join(' ')
        document.body.style.width = bodyWidth.current
      }
    }
  }, [])

  useEffect(() => {
    const bodyClass = document.body.className.split(' ')
    if (!document.body.className.includes('meinian-modal-open')) {
      bodyWidth.current = document.body.style.width || ''
    }
    if (document.querySelector('.meinian-modal .mask')) {
      document.body.className += ' meinian-modal-open'
      document.body.style.width = `calc(100% - ${getScrollBarSize()}px)`
    } else if (document.querySelectorAll('.meinian-modal .mask').length < 2) {
      document.body.className = bodyClass.filter(m => m !== 'meinian-modal-open').join(' ')
      document.body.style.width = bodyWidth.current
    }
  }, [visible])

  const close = () => {
    unmount && unmount()
    onClose && onClose()
    onVisibleChange && onVisibleChange(false)
  }

  const onClickWrap = (e) => {
    if (!maskClosable) { return }
    if (e.target === $wrap.current) {
      cancel()
    }
  }
  const cancel = () => {
    close()
    onCancel && onCancel()
  }
  const ok = async () => {
    const flag = await onOk?.()
    if (flag === false) {
      return
    }
    closeAfterOk && close()
  }
  return ReactDOM.createPortal(
    <div className={classNames('meinian-modal', className)} style={wrapStyle} onClick={e => e && e.stopPropagation()}>
      {visible || typeof (visible) !== 'boolean' ? <><div className="mask" />
        <div className="modal-wrap" onClick={e => onClickWrap(e)} ref={$wrap}>
          <div className={classNames('modal', size)} style={style}>
            {hiddenCloseIcon ? null : <span className="close-icon" onClick={cancel}>{closeIcon || <Icon type="m-guanbi" />}</span>}
            { title ? <div className="modal-title">{title}</div> : null}
            <div className="modal-content">{props.children}</div>
            {hiddenFooter ? null : <div className="modal-footer">
              {footer || <>
                {confirm ? <Button type="primary" width={320} onClick={ok} style={{ display: 'block', margin: 'auto' }}>{confirmText || '确定'}</Button> : null}
                {(info || confirm) ? null : <>
                  <Button type="normal" onClick={cancel} style={{ marginRight: 8, width: 88 }}>{cancelText || '取消'}</Button>
                  <Button type="primary" style={{ width: 88 }} onClick={ok}>{okText || '确定'}</Button>
                </>}
              </>}
            </div>}
          </div>
        </div></> : null}
    </div>,
    document.body
  )
}
Modal.show = (props) => {
  const div = document.createElement('div')
  return new Promise(() => {
    renderCompat(<Modal {...props} visible container={div} />, div)
  })
}
Modal.confirm = (props) => {
  const div = document.createElement('div')
  return new Promise(() => {
    renderCompat(<Modal {...props} confirm visible container={div} />, div)
  })
}
Modal.info = (props) => {
  const div = document.createElement('div')
  return new Promise(() => {
    renderCompat(<Modal {...props} info visible container={div} />, div)
  })
}

export default Modal
